export class BloqueoBipRequest {
  "username": string;
  "otp": string;
  "token": string;

  public constructor() {}
}
